(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.theme = factory());
})(this, (function () { 'use strict';

  // DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
  // ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN
  const colors = {},
    fontFamilies = {},
    lineHeights = {},
    fontWeights = {},
    fontSizes = {},
    spacing = {},
    sizing = {},
    borderRadius = {},
    boxShadow = {},
    borderWidth = {},
    motion = {},
    opacity = {},
    letterSpacings = {};

  colors.black10 = '#fafbfc';
  colors.black15 = '#f5f7fA';
  colors.black20 = '#e7eeec';
  colors.black30 = '#b8c4c2';
  colors.black40 = '#9fa1a2';
  colors.black50 = '#5d6c74';
  colors.black60 = '#3d4f58';
  colors.black70 = '#21313c';
  colors.black80 = '#061621';
  colors.black00 = '#ffffff';
  colors.blue05 = '#EEFDFA';
  colors.blue10 = '#E3FCF7';
  colors.blue20 = '#A6FFEC';
  colors.blue30 = '#53E9F6';
  colors.blue40 = '#00D2FF';
  colors.blue50 = '#009FFD';
  colors.blue60 = '#006CFA';
  colors.blue70 = '#0D427C';
  colors.blue80 = '#001E2B';
  colors.purple05 = '#FBF3FF';
  colors.purple10 = '#F9EBFF';
  colors.purple20 = '#F2C5EE';
  colors.purple30 = '#D38FF0';
  colors.purple40 = '#B45AF2';
  colors.purple50 = '#983FF9';
  colors.purple60 = '#7C25FF';
  colors.purple70 = '#5400F8';
  colors.purple80 = '#2A0F91';
  colors.green05 = '#F8FFEA';
  colors.green10 = '#F4FFDC';
  colors.green20 = '#E9FF99';
  colors.green30 = '#B1FF05';
  colors.green40 = '#00ED64';
  colors.green50 = '#00AA57';
  colors.green60 = '#00684A';
  colors.green70 = '#014E3D';
  colors.green80 = '#023430';
  colors.yellow05 = '#FEFAE9';
  colors.yellow10 = '#FEF7DB';
  colors.yellow20 = '#FFEC9E';
  colors.yellow30 = '#FBDB5A';
  colors.yellow40 = '#FFC010';
  colors.yellow50 = '#F28900';
  colors.yellow60 = '#944F01';
  colors.yellow70 = '#4C2100';
  colors.yellow80 = '#2F1400';
  colors.red05 = '#FFF2EF';
  colors.red10 = '#FFEAE5';
  colors.red20 = '#FFCDC7';
  colors.red30 = '#FF6960';
  colors.red40 = '#F3461F';
  colors.red50 = '#DB3030';
  colors.red60 = '#970606';
  colors.red70 = '#5B0000';
  colors.red80 = '#430404';
  colors.text = {
    default: colors.blue80,
    defaultBody: colors.black60,
    secondary: colors.black50,
    inverse: colors.black00,
    inverseBody: colors.black30,
    inverseSecondary: colors.black30,
    error: colors.red50,
    errorInverse: colors.red30,
    neutral: colors.black50,
    selected: colors.green70,
    inverseSelected: colors.green40,
    mark: colors.green60,
    inverseMark: colors.green40,
    eyebrowDefault: colors.green60,
    eyebrowInverse: colors.green40,
    eyebrowInverseSecondary: colors.black00,
    checkbox: colors.green40
  };
  colors.border = {
    default: colors.black30,
    inverse: colors.black50,
    inverseDarker: colors.black60
  };
  colors.icon = {
    error: colors.red50,
    errorInverse: colors.red30,
    warning: colors.yellow40,
    branded: {
      primary: colors.blue80,
      secondary: colors.green40,
      inversePrimary: colors.black00,
      inverseSecondary: colors.green40
    },
    system: {
      default: colors.black60,
      defaultNeutral: colors.black50,
      inverse: colors.black00,
      inverseNeutral: colors.black30,
      success: colors.green60,
      successInverse: colors.green40
    }
  };
  colors.background = {
    body: colors.black00,
    container: colors.black10,
    containerLight: colors.black15,
    containerLighter: colors.black00,
    containerInverse: colors.blue80,
    containerInverseDarker: colors.black80,
    selected: colors.green40,
    selectedLighter: colors.green10,
    panel: colors.black00,
    selectedInverseLighter: colors.black60
  };
  colors.button = {
    primary: {
      bg: colors.green40,
      bgDisabled: colors.black30,
      text: colors.blue80,
      textDisabled: colors.black50,
      border: colors.green60,
      borderDisabled: colors.black70
    },
    secondary: { bg: colors.blue80, text: colors.black00 },
    inversePrimary: {
      bg: colors.green40,
      bgDisabled: colors.black60,
      text: colors.blue80,
      textDisabled: colors.black30,
      border: colors.green60,
      borderDisabled: colors.black70
    },
    inverseSecondary: { bg: colors.black00, text: colors.blue80 },
    utility: {
      bg: colors.green40,
      border: colors.green60,
      icon: colors.green80,
      iconInverse: colors.black00,
      borderInverse: colors.green40,
      bgHover: colors.green80,
      bgHoverInverse: colors.black00
    }
  };
  colors.forms = {
    textInput: {
      default: {
        bg: colors.black10,
        bgDisabled: colors.black10,
        border: colors.blue80,
        text: colors.blue80,
        label: colors.black50,
        labelFilled: colors.black60,
        icon: colors.blue80,
        helpText: colors.blue80,
        focus: { border: colors.blue60, label: colors.blue60 },
        error: {
          label: colors.red50,
          border: colors.red50,
          icon: colors.red50,
          labelFocus: colors.red60,
          borderFocus: colors.red60,
          iconFocus: colors.red60
        }
      },
      inverse: {
        bg: colors.black70,
        bgDisabled: colors.black70,
        border: colors.black00,
        text: colors.black00,
        label: colors.black30,
        labelFilled: colors.black10,
        icon: colors.black00,
        helpText: colors.black10,
        focus: { border: colors.blue40, label: colors.blue40 },
        error: {
          label: colors.red30,
          border: colors.red30,
          icon: colors.red30,
          labelFocus: colors.red50,
          borderFocus: colors.red50,
          iconFocus: colors.red50
        }
      }
    },
    checkbox: {
      bgSelected: colors.green60,
      icon: colors.black00,
      boxBorder: colors.blue80,
      bg: colors.black00,
      bgDisabled: colors.black20,
      iconDisabled: colors.black00,
      focusBorder: colors.blue60,
      bgSelectedDisabled: colors.black50,
      boxBorderDisabled: colors.black50
    },
    checkboxInverse: {
      bgSelected: colors.green40,
      icon: colors.blue80,
      boxBorder: colors.black00,
      bg: colors.blue80,
      bgDisabled: colors.black70,
      iconDisabled: colors.black00,
      focusBorder: colors.blue40,
      bgSelectedDisabled: colors.black50,
      boxBorderDisabled: colors.black50
    },
    radioButton: {
      bg: colors.black00,
      boxBorder: colors.blue80,
      focusBorder: colors.blue60,
      icon: colors.green60,
      boxBorderDisabled: colors.black50,
      bgDisabled: colors.black20,
      iconDisabled: colors.black40
    },
    radioButtonInverse: {
      bg: colors.blue80,
      boxBorder: colors.black00,
      focusBorder: colors.blue40,
      icon: colors.green40,
      boxBorderDisabled: colors.black50,
      bgDisabled: colors.black70,
      iconDisabled: colors.black50
    }
  };
  colors.link = {
    cta: {
      default: {
        text: colors.blue80,
        icon: colors.green60,
        textDisabled: colors.black50,
        iconDisabled: colors.black50,
        textHover: colors.green60
      },
      inverse: {
        text: colors.black00,
        icon: colors.green40,
        textHover: colors.green40
      }
    },
    navigation: { text: colors.black70, textSelected: colors.green50 },
    footer: { text: colors.black00, textSelected: colors.green40 },
    inline: {
      default: { text: colors.blue60, underline: colors.black80 },
      inverse: { text: colors.green40, underline: colors.black00 }
    }
  };
  colors.pill = {
    identifier: {
      primary: { text: colors.blue80, bgInformational: colors.blue10 },
      secondary: {
        textInformational: colors.black00,
        bgInformational: colors.blue60
      },
      inverse: { borderInformational: colors.blue10, inverseText: colors.blue10 }
    },
    badge: {
      default: { bg: colors.green30, text: colors.green70 },
      inverse: { bg: colors.green30, text: colors.green70 }
    }
  };
  colors.tag = {
    border: colors.blue60,
    text: colors.blue60,
    bg: colors.blue10,
    inverseBorder: colors.blue40,
    inverseText: colors.blue40,
    inverseBG: colors.blue80
  };
  colors.panels = {
    default: {
      bg: colors.black10,
      bgLighter: colors.black00,
      border: colors.black30
    },
    inverse: {
      bg: colors.black70,
      bgDarker: colors.black80,
      border: colors.black50
    },
    navigation: { bg: colors.black00, border: colors.black30 },
    card: {
      bg: colors.black00,
      bgDarker: colors.black10,
      border: colors.black30
    },
    modal: {
      bg: colors.black00,
      bgDarker: colors.black10,
      border: colors.black30
    },
    notification: {
      bgSuccess: colors.green10,
      borderSuccess: colors.green20,
      bgAlert: colors.yellow10,
      borderAlert: colors.yellow40,
      bgNote: colors.blue10,
      borderNote: colors.blue20,
      bgDanger: colors.yellow20,
      borderDanger: colors.yellow60,
      innerSuccess: colors.green80,
      innerNote: colors.blue80,
      innerDanger: colors.yellow50,
      innerAlert: colors.yellow30
    },
    tooltip: {
      bgInverse: colors.black70,
      borderInverse: colors.black50,
      bg: colors.black00,
      border: colors.black30
    },
    popover: {
      bg: colors.black00,
      border: colors.black30,
      bgInverse: colors.black70,
      borderInverse: colors.black50
    },
    select: {
      bg: colors.black00,
      bgInverse: colors.black70,
      borderInverse: colors.black50,
      border: colors.black30
    }
  };
  colors.tabs = {
    tertiary: {
      inverse: {
        borderHover: colors.blue60,
        bgActive: colors.blue60,
        bg: colors.black60,
        textActive: colors.black00,
        textInactive: colors.black00
      },
      default: {
        borderHover: colors.blue60,
        bgActive: colors.blue60,
        bg: colors.black20,
        textActive: colors.black00,
        textInactive: colors.black80
      }
    }
  };
  colors.code = {
    bg: colors.black80,
    bgLines: colors.black70,
    lines: colors.blue10,
    copyBG: colors.black70,
    operators: colors.black10,
    comments: colors.black40,
    definitions: colors.yellow20,
    numbers: colors.purple20,
    keywords: '#FFA1A1',
    variables: colors.blue20,
    type: colors.blue20,
    strings: colors.yellow20,
    attributes: colors.green20
  };
  colors.card = {
    default: {
      bg: colors.black00,
      border: colors.black20,
      textSub: colors.green60,
      borderDarker: colors.green80
    },
    inverse: {
      bg: colors.blue80,
      border: colors.black70,
      textSub: colors.green40,
      borderLighter: colors.green40
    }
  };
  colors.header = {
    default: {
      title: colors.blue80,
      text: colors.blue80,
      eyebrow: colors.green60,
      bg: colors.black00,
      bgDarker: colors.black10
    },
    inverse: {
      title: colors.black00,
      text: colors.black00,
      eyebrow: colors.green40,
      bg: colors.blue80,
      bgLighter: colors.green80
    }
  };
  colors.list = {
    default: {
      text: colors.blue80,
      bullet: colors.blue60,
      checkmark: colors.green40
    },
    inverse: {
      text: colors.black00,
      bullet: colors.green40,
      checkmark: colors.green40
    }
  };

  fontFamilies.menlo = 'Menlo';
  fontFamilies['akzidenz-grotesk-std'] =
    'Akzidenz-Grotesk Std,Noto Sans KR,Noto Sans SC,Noto Sans JP';
  fontFamilies['euclid-circular-a'] =
    'Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP';
  fontFamilies['source-code-pro'] = 'Source Code Pro';
  fontFamilies['mongodb-value-serif'] =
    'MongoDB Value Serif,Noto Sans KR,Noto Sans SC,Noto Sans JP';
  fontFamilies.heading = fontFamilies['mongodb-value-serif'];
  fontFamilies.body = fontFamilies['euclid-circular-a'];
  fontFamilies.mono = fontFamilies['source-code-pro'];

  lineHeights.inc00 = 16;
  lineHeights.inc10 = 18;
  lineHeights.inc20 = 24;
  lineHeights.inc30 = 32;
  lineHeights.inc40 = 40;
  lineHeights.inc50 = 48;
  lineHeights.inc60 = 56;
  lineHeights.inc70 = 64;
  lineHeights.inc80 = 72;
  lineHeights.inc90 = 112;
  lineHeights.headingXXL = lineHeights.inc90;
  lineHeights.headingXL = lineHeights.inc80;
  lineHeights.headingL = lineHeights.inc70;
  lineHeights.headingM = lineHeights.inc60;
  lineHeights.headingS = lineHeights.inc50;
  lineHeights.headingXS = lineHeights.inc30;
  lineHeights.headingXXLResponsive = lineHeights.inc60;
  lineHeights.headingXLResponsive = lineHeights.inc50;
  lineHeights.headingLResponsive = lineHeights.inc40;
  lineHeights.headingMResponsive = lineHeights.inc30;
  lineHeights.headingSResponsive = lineHeights.inc30;
  lineHeights.headingXSResponsive = lineHeights.inc20;
  lineHeights.bodyL = lineHeights.inc30;
  lineHeights.bodyM = lineHeights.inc30;
  lineHeights.bodyS = lineHeights.inc20;
  lineHeights.bodyXS = lineHeights.inc00;
  lineHeights.bodyLResponsive = lineHeights.inc30;
  lineHeights.bodyMResponsive = lineHeights.inc30;
  lineHeights.bodySResponsive = lineHeights.inc20;
  lineHeights.bodyXSResponsive = lineHeights.inc00;
  lineHeights.monoL = lineHeights.inc30;
  lineHeights.monoM = lineHeights.inc20;
  lineHeights.monoS = lineHeights.inc00;
  lineHeights.monoLResponsive = lineHeights.inc30;
  lineHeights.monoMResponsive = lineHeights.inc20;
  lineHeights.monoSResponsive = lineHeights.inc00;

  fontWeights.medium = 'Medium';
  fontWeights.light = 'Light';
  fontWeights.regular = 'Regular';
  fontWeights.bold = 'Bold';
  fontWeights.semibold = 'Semibold';

  fontSizes.inc00 = 12;
  fontSizes.inc10 = 14;
  fontSizes.inc20 = 16;
  fontSizes.inc30 = 18;
  fontSizes.inc40 = 20;
  fontSizes.inc50 = 24;
  fontSizes.inc60 = 28;
  fontSizes.inc70 = 32;
  fontSizes.inc80 = 36;
  fontSizes.inc90 = 40;
  fontSizes.inc100 = 44;
  fontSizes.inc110 = 48;
  fontSizes.inc120 = 56;
  fontSizes.inc130 = 64;
  fontSizes.inc140 = 96;
  fontSizes.headingXXL = fontSizes.inc140;
  fontSizes.headingXL = fontSizes.inc130;
  fontSizes.headingL = fontSizes.inc120;
  fontSizes.headingM = fontSizes.inc100;
  fontSizes.headingS = fontSizes.inc80;
  fontSizes.headingXS = fontSizes.inc50;
  fontSizes.headingXXLResponsive = fontSizes.inc110;
  fontSizes.headingXLResponsive = fontSizes.inc90;
  fontSizes.headingLResponsive = fontSizes.inc70;
  fontSizes.headingMResponsive = fontSizes.inc60;
  fontSizes.headingSResponsive = fontSizes.inc50;
  fontSizes.headingXSResponsive = fontSizes.inc30;
  fontSizes.bodyL = fontSizes.inc40;
  fontSizes.bodyM = fontSizes.inc30;
  fontSizes.bodyS = fontSizes.inc20;
  fontSizes.bodyXS = fontSizes.inc10;
  fontSizes.bodyLResponsive = fontSizes.inc30;
  fontSizes.bodyMResponsive = fontSizes.inc20;
  fontSizes.bodySResponsive = fontSizes.inc10;
  fontSizes.bodyXSResponsive = fontSizes.inc10;
  fontSizes.monoL = fontSizes.inc20;
  fontSizes.monoM = fontSizes.inc10;
  fontSizes.monoS = fontSizes.inc00;
  fontSizes.monoLResponsive = fontSizes.inc20;
  fontSizes.monoMResponsive = fontSizes.inc10;
  fontSizes.monoSResponsive = fontSizes.inc00;

  spacing.base = 8;
  spacing.inc00 = 0;
  spacing.neg00 = 0;
  spacing.section00 = spacing.base;
  spacing.section10 = spacing.base * 2;
  spacing.section20 = spacing.base * 3;
  spacing.section30 = spacing.base * 6;
  spacing.section40 = spacing.base * 8;
  spacing.section50 = spacing.base * 12;
  spacing.section60 = spacing.base * 14;
  spacing.inc10 = spacing.base * 0.5;
  spacing.inc20 = spacing.base * 1;
  spacing.inc30 = spacing.base * 2;
  spacing.inc40 = spacing.base * 3;
  spacing.inc50 = spacing.base * 4;
  spacing.inc60 = spacing.base * 5;
  spacing.inc70 = spacing.base * 6;
  spacing.inc80 = spacing.base * 7;
  spacing.inc90 = spacing.base * 8;
  spacing.inc100 = spacing.base * 9;
  spacing.inc110 = spacing.base * 10;
  spacing.inc120 = spacing.base * 11;
  spacing.inc130 = spacing.base * 12;
  spacing.inc140 = spacing.base * 13;
  spacing.inc150 = spacing.base * 14;
  spacing.inc160 = spacing.base * 15;
  spacing.neg10 = spacing.base * -0.5;
  spacing.neg20 = spacing.base * -1;
  spacing.neg30 = spacing.base * -2;
  spacing.neg40 = spacing.base * -3;
  spacing.neg50 = spacing.base * -4;
  spacing.neg60 = spacing.base * -5;
  spacing.neg70 = spacing.base * -6;
  spacing.neg80 = spacing.base * -7;
  spacing.neg90 = spacing.base * -8;
  spacing.sectionGapZero = spacing.inc00;
  spacing.sectionGapXXSmall = spacing.section00;
  spacing.sectionGapXSmall = spacing.section10;
  spacing.sectionGapSmall = spacing.section20;
  spacing.sectionGapMedium = spacing.section30;
  spacing.sectionGapLarge = spacing.section40;
  spacing.sectionGapXLarge = spacing.section50;
  spacing.sectionGapXXLarge = spacing.section60;
  spacing.elementZero = spacing.inc00;
  spacing.elementXSmall = spacing.inc30;
  spacing.elementSmall = spacing.inc40;
  spacing.elementMedium = spacing.inc50;
  spacing.elementLarge = spacing.inc60;
  spacing.elementXLarge = spacing.inc70;
  spacing.colGapSmall = spacing.inc30;
  spacing.colGapMedium = spacing.inc40;
  spacing.outsideGutterSmall = spacing.inc40;
  spacing.outsideGutterMedium = spacing.inc50;
  spacing.outsideGutterLarge = spacing.inc70;
  spacing.cards = {
    paddingXXS: spacing.inc40,
    paddingXS: spacing.inc50,
    paddingS: spacing.inc60,
    paddingM: spacing.inc70,
    paddingL: spacing.inc80,
    paddingXL: spacing.inc110,
    paddingXXL: spacing.inc160
  };
  spacing.responsive = {
    verticalGap: {
      sectionZero: { small: 0, medium: 0, large: 0, xlarge: 0, xxlarge: 0 },
      sectionXXSmall: {
        small: spacing.section00,
        medium: spacing.section00,
        large: spacing.section00,
        xlarge: spacing.section00,
        xxlarge: spacing.section00
      },
      sectionXSmall: {
        small: spacing.section10,
        medium: spacing.section10,
        large: spacing.section10,
        xlarge: spacing.section10,
        xxlarge: spacing.section10
      },
      sectionSmall: {
        small: spacing.section20,
        medium: spacing.section20,
        large: spacing.section20,
        xlarge: spacing.section20,
        xxlarge: spacing.section20
      },
      sectionMedium: {
        small: spacing.section30,
        medium: spacing.section30,
        large: spacing.section30,
        xlarge: spacing.section30,
        xxlarge: spacing.section30
      },
      sectionLarge: {
        small: spacing.sectionGapMedium,
        medium: spacing.sectionGapMedium,
        large: spacing.section40,
        xlarge: spacing.section40,
        xxlarge: spacing.section40
      },
      sectionXLarge: {
        small: spacing.inc80,
        medium: spacing.inc80,
        large: spacing.section50,
        xlarge: spacing.section50,
        xxlarge: spacing.section50
      },
      sectionXXLarge: {
        small: spacing.sectionGapLarge,
        medium: spacing.sectionGapLarge,
        large: spacing.section60,
        xlarge: spacing.section60,
        xxlarge: spacing.section60
      }
    },
    columnGap: {
      tight: {
        small: spacing.inc20,
        medium: spacing.inc30,
        large: spacing.inc40,
        xlarge: spacing.inc40,
        xxlarge: spacing.inc40
      },
      normal: {
        small: spacing.inc30,
        medium: spacing.inc50,
        large: spacing.inc70,
        xlarge: spacing.inc70,
        xxlarge: spacing.inc70
      },
      loose: {
        small: spacing.inc40,
        medium: spacing.inc60,
        large: spacing.inc90,
        xlarge: spacing.inc90,
        xxlarge: spacing.inc90
      },
      huge: {
        small: spacing.inc60,
        medium: spacing.inc80,
        large: spacing.inc130,
        xlarge: spacing.inc130,
        xxlarge: spacing.inc130
      }
    },
    cells: {
      normal: {
        vertical: {
          small: spacing.inc40,
          medium: spacing.inc50,
          large: spacing.inc70,
          xlarge: spacing.inc70
        },
        left: {
          small: spacing.inc30,
          medium: spacing.inc30,
          large: spacing.inc30,
          xlarge: spacing.inc30,
          xxlarge: spacing.inc30
        },
        right: {
          small: spacing.inc30,
          medium: spacing.inc30,
          large: spacing.inc30,
          xlarge: spacing.inc30,
          xxlarge: spacing.inc30
        }
      },
      tight: {
        vertical: {
          small: spacing.inc20,
          medium: spacing.inc40,
          large: spacing.inc40,
          xlarge: spacing.inc40,
          xxlarge: spacing.inc40
        },
        left: {
          small: spacing.inc30,
          medium: spacing.inc30,
          large: spacing.inc30,
          xlarge: spacing.inc30,
          xxlarge: spacing.inc30
        },
        right: {
          small: spacing.inc30,
          medium: spacing.inc30,
          large: spacing.inc30,
          xlarge: spacing.inc30,
          xxlarge: spacing.inc30
        }
      }
    }
  };

  sizing.base = 8;
  sizing.maxWidthDesktop = 1416;
  sizing.inc00 = sizing.base * 0.5;
  sizing.inc10 = sizing.base * 2;
  sizing.inc20 = sizing.base * 3;
  sizing.inc30 = sizing.base * 4;
  sizing.inc40 = sizing.base * 5;
  sizing.inc50 = sizing.base * 6;
  sizing.inc60 = sizing.base * 7;
  sizing.inc70 = sizing.base * 8;
  sizing.inc80 = sizing.base * 9;
  sizing.inc90 = sizing.base * 10;
  sizing.inc100 = sizing.base * 11;
  sizing.systemIconLarge = sizing.inc30;
  sizing.systemIconMedium = sizing.inc20;
  sizing.systemIconSmall = sizing.inc10;
  sizing.systemIconXSmall = sizing.inc00 * 3;
  sizing.codeSnippetSmall = sizing.base * 35;
  sizing.codeSnippetMedium = sizing.base * 60;
  sizing.codeSnippetLarge = sizing.base * 90;
  sizing.brandedIconSmall = sizing.inc50;
  sizing.brandedIconMedium = sizing.inc70;
  sizing.brandedIconLarge = sizing.inc90;
  sizing.breakpoint = {
    small: 460,
    medium: 768,
    large: 1024,
    xlarge: 1280,
    xxlarge: 1440
  };

  borderRadius.circle = 999;
  borderRadius.inc00 = 0;
  borderRadius.inc10 = 2;
  borderRadius.inc20 = 4;
  borderRadius.inc30 = 8;
  borderRadius.inc40 = 16;
  borderRadius.inc50 = 24;
  borderRadius.inc60 = 32;
  borderRadius.inc70 = 40;
  borderRadius.inc80 = 56;
  borderRadius.inc90 = 72;
  borderRadius.inc100 = 88;
  borderRadius.inc110 = 104;
  borderRadius.inc120 = 128;
  borderRadius.inc130 = 144;
  borderRadius.buttons = borderRadius.inc20;
  borderRadius.input = borderRadius.inc20;
  borderRadius.modal = borderRadius.inc20;
  borderRadius.tooltips = borderRadius.inc20;
  borderRadius.notification = borderRadius.inc20;
  borderRadius.card = borderRadius.inc70;
  borderRadius.cardResponsive = borderRadius.inc50;
  borderRadius.codePanel = borderRadius.inc60;
  borderRadius.buttonHover = borderRadius.inc70;
  borderRadius.scrollyStoryCard = borderRadius.inc50;
  borderRadius.scrollyStoryCardResponsive = borderRadius.inc40;

  boxShadow.level00 = { x: 0, y: 0, spread: 0, color: '#000000', blur: 0 };
  boxShadow.level01 = {
    x: 0,
    y: 2,
    blur: 4,
    spread: 0,
    color: 'rgba(0,0,0,.10)',
    type: 'innerShadow'
  };
  boxShadow.level02 = { x: 0, y: 3, spread: 0, color: 'rgba(0,0,0,.15)', blur: 9 };
  boxShadow.level03 = {
    x: 0,
    y: 3,
    spread: 0,
    color: 'rgba(0,0,0,.15)',
    blur: 20
  };
  boxShadow.level04 = {
    x: 0,
    y: 6,
    spread: 0,
    color: 'rgba(0,0,0,.15)',
    blur: 30
  };
  boxShadow.buttonHover = {
    x: 0,
    y: 0,
    spread: 3,
    blur: 0,
    color: 'rgba(242, 197, 238, 1)'
  };
  boxShadow.buttonHoverInverse = {
    x: 0,
    y: 0,
    spread: 3,
    color: 'rgba(244, 255, 220, .4)',
    blur: 0
  };
  boxShadow.tagHover = {
    x: 0,
    y: 0,
    spread: 3,
    blur: 0,
    color: 'rgba(0, 108, 250, .4)'
  };
  boxShadow.tagHoverInverse = {
    x: 0,
    y: 0,
    spread: 3,
    color: 'rgba(166, 225, 236, .4)',
    blur: 0
  };

  borderWidth.inc00 = 0;
  borderWidth.inc10 = 1;
  borderWidth.inc20 = 2;
  borderWidth.inc30 = 3;
  borderWidth.ruleBreak = borderWidth.inc10;
  borderWidth.inputs = borderWidth.inc10;
  borderWidth.systemIconSmall = borderWidth.inc10;
  borderWidth.systemIconMedium = borderWidth.inc20;
  borderWidth.systemIconLarge = borderWidth.inc20;

  motion.inc00 = 100;
  motion.inc10 = 200;
  motion.inc20 = 250;
  motion.inc30 = 300;
  motion.inc40 = 350;
  motion.linkAnimation = motion.inc30;
  motion.mobileNavPanel = motion.inc30;
  motion.mobileNavItemExpand = motion.inc30;
  motion.tag = motion.inc00;
  motion.codeSnippetCopyFade = motion.inc30 * 10;
  motion.accordion = motion.inc40;

  opacity.inc00 = '0%';
  opacity.inc10 = '8%';
  opacity.inc20 = '20%';
  opacity.inc30 = '30%';
  opacity.inc40 = '40%';
  opacity.inc50 = '50%';
  opacity.inc60 = '60%';
  opacity.inc70 = '70%';
  opacity.inc80 = '80%';
  opacity.inc90 = '90%';
  opacity.inc100 = '100%';
  opacity.modalScrim = opacity.inc50;

  ({
    thin: borderWidth.inc10,
    medium: borderWidth.inc20,
    thick: borderWidth.inc30
  });

  ({
    activeIndicator: colors.green40,
    bgPanel: '#F5F7FA',
    rule: colors.green70,
    l1: {
      text: colors.blue80,
      textHover: colors.green60,
      bgHover: colors.green80,
      mobile: { icon: colors.green60, seperator: colors.black20 }
    },
    l2: {
      link: colors.blue80,
      linkHover: colors.green60,
      icon: colors.green60,
      description: colors.green60,
      mobile: { link: colors.green60 }
    },
    l3: { link: colors.blue80, linkHover: colors.green60, icon: colors.green60 }
  });
  ({
    activeIndicator: colors.green40,
    bgPanel: colors.black60,
    rule: colors.black00,
    l1: {
      text: colors.black00,
      textHover: colors.green40,
      bgHover: colors.black00,
      mobile: { icon: colors.green40, seperator: colors.black60 }
    },
    l2: {
      link: colors.black00,
      linkHover: colors.green40,
      icon: colors.green40,
      description: colors.black30,
      mobile: { link: colors.green40 }
    },
    l3: { link: colors.black00, linkHover: colors.green40, icon: colors.green40 }
  });

  letterSpacings.eyebrow = 3;

  const transformToUnit = (token, unit) => {
    return Object.entries(token).reduce((acc, [name, value]) => {
      return {
        ...acc,
        [name]:
          typeof value === 'object'
            ? transformToUnit(value, unit)
            : `${value}${unit}`
      }
    }, {})
  };

  const transformToArrays = (token) => {
    return Object.entries(token).reduce((acc, [name, value]) => {
      const values = Object.values(value);
      return {
        ...acc,
        [name]:
          values.length > 0 && typeof values[0] === 'number'
            ? Object.values(value)
            : typeof value === 'object'
              ? transformToArrays(value)
              : []
      }
    }, {})
  };

  // format box shadow tokens to box shadow css shorthand
  const formatToBoxShadow = (boxShadow) => {
    return Object.entries(boxShadow).reduce(
      (acc, [name, { x, y, spread, color, blur }]) => {
        /* offset-x | offset-y | blur-radius | spread-radius | color */
        acc[name] = `${x}px ${y}px ${blur}px ${spread}px ${color}`;
        return acc
      },
      {}
    )
  };

  const convertToPx = (token) => transformToUnit(token, 'px');

  const convertToMs = (token) => transformToUnit(token, 'ms');

  const shadows = formatToBoxShadow(boxShadow);
  const borders = convertToPx(borderWidth);

  var theme = {
    colors,
    shadows,
    borders,
    fonts: fontFamilies,
    fontWeights,
    sizes: convertToPx(sizing),
    radii: convertToPx(borderRadius),
    lineHeights: convertToPx(lineHeights),
    fontSizes: convertToPx(fontSizes),
    space: convertToPx(spacing),
    responsive: transformToArrays(spacing.responsive),
    borderWidths: borders,
    breakpoints: Object.values(convertToPx(sizing.breakpoint)),
    motion: convertToMs(motion),
    opacity,
    letterSpacings: convertToPx(letterSpacings)
  };

  return theme;

}));
